/* Sugaribo Product Card JS (optional UX enhancement)
   - Swatch click -> pick first available variant for that color
   - Select change -> update hidden variant id
   - Low stock label follows selected variant
   - Image follows selected variant (if available)
*/
(function(){
  const LOW = 3;

  const cards = document.querySelectorAll('[data-color-index].bg-surface, .p-card');
  cards.forEach(card => {
    const dataEl = card.querySelector('.p-card__data');
    if (!dataEl) return;

    let variants;
    try { variants = JSON.parse(dataEl.textContent.trim()); }
    catch(e){ return; }

    const select = card.querySelector('select');
    const hiddenId = card.querySelector('.p-qa__variant-id');
    const stockEl = Array.from(card.querySelectorAll('span')).find(el => (el.textContent || '').trim() === '残りわずか');
    const imgEl = card.querySelector('img');
    const colorIndex = parseInt(card.getAttribute('data-color-index') || '-1', 10);

    function applyVariant(vid){
      const v = variants.find(x => String(x.id) === String(vid));
      if (!v) return;

      if (hiddenId) hiddenId.value = v.id;

      if (stockEl){
        const show = v.available && v.qty >= 0 && v.qty <= LOW;
        stockEl.hidden = !show;
        stockEl.classList.toggle('text-danger', show);
        stockEl.classList.toggle('font-bold', show);
        stockEl.classList.toggle('text-muted', !show);
      }

      if (imgEl && v.img) imgEl.src = v.img;
    }

    if (select){
      select.addEventListener('change', () => applyVariant(select.value));
      applyVariant(select.value);
    }

    const swatches = card.querySelectorAll('.p-swatch[data-color]');
    swatches.forEach(btn => {
      btn.addEventListener('click', () => {
        if (colorIndex < 0) return;
        const c = btn.getAttribute('data-color');

        const pick =
          variants.find(v => v.available && v.options && v.options[colorIndex] === c) ||
          variants.find(v => v.options && v.options[colorIndex] === c);

        if (!pick) return;

        if (select) select.value = pick.id;
        applyVariant(pick.id);
      });
    });
  });
})();
